import { useMemo } from "react";
import styled from "styled-components";

import { ReactComponent as CheckIcon } from "../assets/check.svg";
import { ReactComponent as MinusIcon } from "../assets/minus.svg";
import { ReactComponent as CrossIcon } from "../assets/cross.svg";
import { ReactComponent as CalendarIcon } from "../assets/calendar.svg";
import { ReactComponent as MapPointerIcon } from "../assets/map-pointer-blank.svg";

import { InspectionfieldStateEnum } from "./__generated__/InspectionFieldCard.graphql";
import { formatDateShort } from "../utils";
import { StateTitles } from "../pages/InspectionList/StateHelpers";
import TooltipContainer from "./TooltipContainer/TooltipContainer";

const State = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  .icon {
    padding-right: 8px;
    width: 16px;
    text-align: center;
  }
  .text {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 10px;
    text-transform: uppercase;
    align-self: center;
    text-align: center;
  }
`;

function FieldState({
  state,
  text,
  pin,
  onClick,
}: {
  state: InspectionfieldStateEnum;
  text?: string;
  pin?: boolean;
  onClick?: Function;
}) {
  const color = useMemo(() => {
    const colorMap: {
      [key in InspectionfieldStateEnum]?: string;
    } = {
      ASSIGNED: "#0075BC",
      IN_PROGRESS: "#F9BF2B",
      PLANNED: "#9D56E4",
      REJECTED: "#F92B2B",
      APPROVED: "#309E5B",
      RETRY: "#F9BF2B",
    };
    return colorMap[state];
  }, [state]);
  const icon = useMemo(() => {
    const iconMap: {
      [key in InspectionfieldStateEnum | "PIN"]?: React.ReactElement;
    } = {
      IN_PROGRESS: <CalendarIcon fill={color} width={10} height={10} />,
      PLANNED: <CalendarIcon fill={color} width={10} height={10} />,
      REJECTED: <CrossIcon fill={color} width={10} height={10} />,
      APPROVED: <CheckIcon fill={color} width={10} height={10} />,
      RETRY: <MinusIcon fill={color} width={14} height={10} />,
    };
    return iconMap[state];
  }, [state, color]);
  const displayText = useMemo(() => {
    const textMap: { [key in InspectionfieldStateEnum]?: string } = {
      IN_PROGRESS: `Laatst gewijzigd op ${formatDateShort(text)}`,
      PLANNED: `Ingepland op ${formatDateShort(text)}`,
      REJECTED: "Niet akkoord",
      APPROVED: "Akkoord",
      RETRY: "Herstel",
    };
    return textMap[state];
  }, [state, text]);
  if (pin) {
    return (
      <TooltipContainer tooltip={StateTitles[state] || ""}>
        <State
          onClick={(e) => {
            e?.stopPropagation();
            onClick && onClick();
          }}
        >
          <div className="icon">
            <MapPointerIcon fill={color} width={40} height={40} />
          </div>
        </State>
      </TooltipContainer>
    );
  }
  return (
    <State>
      {icon && <div className="icon">{icon}</div>}
      {displayText && (
        <div className="text">
          <b>{displayText}</b>
        </div>
      )}
    </State>
  );
}

export default FieldState;
